import Echo from 'laravel-echo'
import Vue from 'vue'

export default (context) => {
    const { appUrl, pusherAppKey, pusherHost } = context.$config

    const echo = {}

    echo.install = function (Vue) {
        Vue.prototype.$pusher = require('pusher-js')

        // wsHost points the WebSocket at our self-hosted Sockudo server, but
        // pusher-js derives httpHost from `cluster` and silently falls back to
        // SockJS/HTTP against sockjs-eu.pusher.com when a raw WebSocket can't be
        // established (e.g. corporate firewalls that block WS). Sockudo is
        // WebSocket-only and has no SockJS endpoint, so we pin httpHost to it as
        // well and restrict transports to ws/wss so clients never reach Pusher.
        Vue.prototype.$echo = new Echo({
            authEndpoint: `${appUrl}/broadcasting/auth`,
            broadcaster: 'pusher',
            key: pusherAppKey,
            wsHost: pusherHost,
            httpHost: pusherHost,
            wsPort: 443,
            wssPort: 443,
            cluster: 'eu',
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
        })
    }

    Vue.use(echo)
}
